import { apiRequest } from './client'

export type ChatPartner = {
  organizationId: number
  /** Organization legal name (e.g. ООО «Нова»). */
  name: string
}

// Терпимость к обоим написаниям на проводе: API нормализуется к snake_case,
// поэтому читаем camelCase, а при его отсутствии — snake_case.
type MySuppliersPage = {
  items: Array<{
    supplierOrganizationId: number
    supplier_organization_id?: number
    supplierName: string | null
    supplier_name?: string | null
    legal_name?: string | null
  }>
}

type MyCustomersPage = {
  items: Array<{
    buyerOrganizationId?: number
    buyer_organization_id?: number
    buyerName?: string | null
    buyer_name?: string | null
    restaurantOrganizationId?: number
    restaurant_organization_id?: number
    restaurantName?: string | null
    restaurant_name?: string | null
    legal_name?: string | null
  }>
}

const partnerLegalName = (
  legalName: string | null | undefined,
  fallbackName: string | null | undefined,
  orgId: number,
  kind: 'supplier' | 'buyer',
): string => {
  const label = legalName?.trim() || fallbackName?.trim()
  if (label) {
    return label
  }
  return kind === 'supplier' ? `Поставщик #${orgId}` : `Покупатель #${orgId}`
}

export const listChatPartners = async (
  organizationId: number,
  role: 'buyer' | 'supplier',
): Promise<ChatPartner[]> => {
  if (role === 'supplier') {
    const page = await apiRequest<MyCustomersPage>(
      `/supplier/customers/my?organizationId=${organizationId}&page=0&size=50`,
    )
    return page.items.map((item) => {
      const buyerOrgId =
        item.buyerOrganizationId ??
        item.buyer_organization_id ??
        item.restaurantOrganizationId ??
        item.restaurant_organization_id ??
        0
      const buyerName =
        item.buyerName ?? item.buyer_name ?? item.restaurantName ?? item.restaurant_name ?? null
      return {
        organizationId: buyerOrgId,
        name: partnerLegalName(item.legal_name, buyerName, buyerOrgId, 'buyer'),
      }
    })
  }

  const page = await apiRequest<MySuppliersPage>(
    `/buyer/suppliers/my?organizationId=${organizationId}&page=0&size=50`,
  )
  return page.items.map((item) => {
    const supplierOrgId = item.supplierOrganizationId ?? item.supplier_organization_id ?? 0
    return {
      organizationId: supplierOrgId,
      name: partnerLegalName(
        item.legal_name,
        item.supplierName ?? item.supplier_name,
        supplierOrgId,
        'supplier',
      ),
    }
  })
}
